
import gsap from 'gsap'
import { validDigits, SimpleBar, awdScroll, loginPopupClass, searchClass, menuClass, productClass, headerClass } from './bundle'
import {updateCart, removeFromCart} from './CartFunctions'

let homeUrl = document.getElementById('homeUrl').value
let instance = null
class Minicart {
    constructor() {
        if(instance){
            return instance
        }
        instance = this
        // console.log(Product)
        // productClass = new Product(document)
        this.minicart = document.querySelector('.minicart')
        this.minicartWrapper = this.minicart.querySelector('.minicart__wrapper')
        this.minicartBg = this.minicart.querySelector('.minicart__bg')
        this.minicartContainer = this.minicart.querySelector('.minicart__container')
        this.minicartContainerTotal = this.minicart.querySelector('.js-total')
        this.minicartEmpty = this.minicart.querySelector('.minicart-empty')
        // this.minicartItems = this.minicart.querySelectorAll('.minicart__item')
        // console.log(this.minicartItems)

        this.openMinicartBtns = [...document.querySelectorAll('.open-minicart-btn')]
        this.closeMinicartBtns = [...this.minicart.querySelectorAll('.close-minicart-btn')]
        
        this.iconaBagQty = document.querySelector('.js-bag-counter')
        

        //External
        this.header = document.querySelector('header')

        /**
         * MOBILE
         */
        this.containerMobileMenus = document.querySelector('.container-mobile-menus')

        this.isAnimating = false
        this.timeout = null

        this.init()

    }

    //Eventi che possono essere inizializzati senza dover reinizializzare dopo le chiamate AJAX
    init() {
        this.openMinicartBtns.forEach(openBtn => {
            openBtn.addEventListener('click', () => {
                if (this.isAnimating) return
                this.isAnimating = true
                const isCartEmpty = parseInt(this.minicart.getAttribute('data-total-item')) > 0 ? false : true
                const args = {
                    isCartEmpty
                }
                awdScroll.stop()
                this.header.classList.remove('active')
                this.header.classList.add('header-bloccato')
                // headerClass.chiudiHeaderFeedVino()
                this.beforeOpen()
                if(document.querySelector('.popup-active') !== null){
                    const dataOtherPopup = document.querySelector('.popup-active').getAttribute('data-popup-element')
                    if(dataOtherPopup === 'login'){
                        loginPopupClass.closeLoginPopup().then( () => {
                            this.open(args)
                        })
                    }
                    else if(dataOtherPopup === 'search'){
                        searchClass.closeSearch().then( () => {
                            this.open(args)
                        })
                    }
                    else if(dataOtherPopup === 'menu'){
                        //Passo il valore minicart perchè altrimenti non si resetta l'icona dell'hamburger
                        menuClass.closeMenu('minicart').then( () => {
                            this.open(args)
                        })
                    }
                }
                //Menu mobile aperto
                else if(this.containerMobileMenus.classList.contains('menu-mobile-active')){
                    if(this.containerMobileMenus.querySelector('.submenu-mobile.opened') !== null){
                        menuClass.closeSubmenuMobile()
                    }
                    menuClass.closeMenuMobile().then( () => {
                        this.open(args)
                    })
                }
                else{
                    this.open(args)
                }
            })
        })    

        this.closeMinicartBtns = [...this.minicart.querySelectorAll('.close-minicart-btn')]
        this.closeMinicartBtns.forEach(closeBtn => {
            closeBtn.addEventListener('click', () => {
                if (this.isAnimating) return
                this.isAnimating = true
                if(document.querySelector('.page-single-product') !== null){
                    headerClass.apriHeaderFeedVino()
                    if( document.querySelector('.popup-acquista').classList.contains('opened')){
                        // productClass.closePopupAcquista()
                        productClass.movePopupAcquista('right')
                        this.close()
                    }
                    else{
                        productClass.resetPopupAcquista()
                        this.close().then(() => {
                            awdScroll.start()
                            this.header.classList.add('active')
                            this.header.classList.remove('header-bloccato') 
                        })
                    }
                }
                else{
                    this.close().then(() => {
                        awdScroll.start()
                        this.header.classList.add('active')
                        this.header.classList.remove('header-bloccato') 
                    })
                }
                //Alla chiusura del carrello potrei aver variato la quantità, quindi se sono nella pagina checkout aggiorno AJAX
                if(document.querySelector('.page-checkout')){
                    document.dispatchEvent(new Event("update_checkout"))
                    document.querySelector('body').dispatchEvent(new Event("update_checkout")) 
                }
            })
        })        
    }

    beforeOpen(){
        gsap.set(this.minicart, {
            y: '0%'
        })
        // gsap.to(this.iconaBagQty, {
        //     duration: 0.4,
        //     autoAlpha: 0
        // })
        gsap.set(this.minicart, {
            autoAlpha: 1
        })
        gsap.to(this.minicartBg, {
            duration: 0.6,
            autoAlpha: 1,
            delay: 0.3
        })
    }


    open(args = {}) {
        return new Promise( resolve => {
            this.minicart.classList.add('opened')
            gsap.timeline()
                .to(this.minicartWrapper, {
                    duration: 1.2,
                    ease: 'power2.inOut',
                    x: '0%',
                    onComplete: () => {
                        if(!args.isCartEmpty){
                            this.initAjaxEvents()
                        }
                        this.isAnimating = false
                        resolve()

                    }
                })

        })
    }

    close() {
        return new Promise( resolve => {
            this.minicart.classList.remove('opened')
            // awdScroll.start()
            // this.header.classList.add('active')
            // this.header.classList.remove('header-bloccato')            
            gsap.timeline({onComplete: resolve})
                .to(this.minicartWrapper, {
                    duration: 1.2,
                    ease: 'power2.inOut',
                    x: '100%'
                })
                .to(this.minicartBg, {
                    duration: 0.6,
                    autoAlpha: 0
                }, '-=0.2')
                .to(this.minicart, {
                    duration: 0,
                    autoAlpha: 0
                })
                .add(() => {
                    this.isAnimating = false;
                })

        })
    }



    

    //Reinizializzo gli elementi e riattivo le funzioni dopo la chiamata AJAX
    initAjaxEvents() {
        this.selectQty()
        this.contentWrapper = this.minicart.querySelector('.content__wrapper')
        new SimpleBar(this.contentWrapper, { autoHide: true })
        this.removeBtns = [...this.minicart.querySelectorAll('.item__remove')]
        this.removeBtns.forEach(removeBtn => {
            removeBtn.addEventListener('click', () => {
                if (this.isAnimating) return
                this.isAnimating = true
                let key = removeBtn.closest('.minicart__item').getAttribute('data-key')
                this.removeItem(key)
            })
        })
    }

    selectQty(){        
        this.inputQtyContainers = [...this.minicart.querySelectorAll('.info__qty')]
        this.inputQtyContainers.forEach( inputQtyContainer => {
            let minicartItem = inputQtyContainer.closest('.minicart__item')
            let inputQty = inputQtyContainer.querySelector('.input-qty')
            let quantitaSelezionata = Number(inputQty.value)
            //!todo: METTERE MASSIMA DISPONIBILITA' REALE VINO
            let disponibilita = 98
            if(minicartItem.getAttribute('data-product-category') === 'hospitality'){
                disponibilita = Number(minicartItem.getAttribute('data-posti-disponibili'))
            }
            else{
                if(minicartItem.getAttribute('data-disponibilita')){
                    disponibilita = Number(minicartItem.getAttribute('data-disponibilita'))
                }
            }
            // console.log(disponibilita)
            let productType = minicartItem.getAttribute('data-product-type')
            let itemArgs = {
                productType,
                inputQtyContainer: inputQtyContainer,
                itemPrice: minicartItem.getAttribute('data-price'),
                itemSubtotal: minicartItem.querySelector('.js-info-subtotal'),
                itemKey: minicartItem.getAttribute('data-key'),
                productId: minicartItem.getAttribute('data-product-id'),
                sizeId: minicartItem.getAttribute('data-size-id')
            }

            let addQtyBtn = inputQtyContainer.querySelector('.qty__action--add')
            addQtyBtn.addEventListener('click', () => {
                if(quantitaSelezionata >= disponibilita) return                
                quantitaSelezionata++
                this.update({...itemArgs, ...{quantitaSelezionata: quantitaSelezionata, inputQty: inputQty}})
            })

            let removeQtyBtn = inputQtyContainer.querySelector('.qty__action--remove')
            removeQtyBtn.addEventListener('click', () => {
                if(quantitaSelezionata < 2) return
                quantitaSelezionata--
                this.update({...itemArgs, ...{quantitaSelezionata: quantitaSelezionata, inputQty: inputQty}})
            })
            
            inputQty.addEventListener('keyup', () => {
                inputQty.value = gsap.utils.clamp(1,disponibilita,Number(inputQty.value))
                let field = inputQty.value

                quantitaSelezionata = validDigits(field)
                if(quantitaSelezionata === ''){
                    quantitaSelezionata = 1
                }
                // let prezzoTotaleFormattato = Number(this.prezzo * this.quantitaSelezionata).toLocaleString("it-IT", { minimumFractionDigits: 2 });
                // this.totale.innerHTML = prezzoTotaleFormattato + ' €'
                this.update({...itemArgs, ...{quantitaSelezionata: quantitaSelezionata, inputQty: inputQty}})
            })


            inputQty.addEventListener('blur', () => {
                let field = inputQty.value
                if (field == '') {
                    inputQty.value = 1
                }
                quantitaSelezionata = inputQty.value
                // let prezzoTotaleFormattato = Number(this.prezzo * this.quantitaSelezionata).toLocaleString("it-IT", { minimumFractionDigits: 2 });
                // this.totale.innerHTML = prezzoTotaleFormattato + ' €'
            })            
        })
    }

    calcSubtotal(itemPrice, quantitaSelezionata){
        const subtotal = itemPrice*quantitaSelezionata
        const subtotalString = Number(Math.round(parseFloat(subtotal + 'e' + 2)) + 'e-' + 2).toFixed(2)
        return subtotalString
    }

    update(args){
        args.inputQty.value = args.quantitaSelezionata
        this.toggleQtyBtns(args.inputQtyContainer)
        // this.hideContainerTotal()
        args.itemSubtotal.innerHTML = this.calcSubtotal(args.itemPrice, args.quantitaSelezionata)        
        clearTimeout(this.timeout)
        this.timeout = setTimeout( () => {
            updateCart(args.productId, args.sizeId, args.itemKey, args.quantitaSelezionata).then( () => {                
                // this.showContainerTotal()
            })
        },200)   

    }

    toggleQtyBtns(inputQtyContainer){
        let inputQty = inputQtyContainer.querySelector('.input-qty')
        let addQtyBtn = inputQtyContainer.querySelector('.qty__action--add')
        let removeQtyBtn = inputQtyContainer.querySelector('.qty__action--remove')
        if(inputQty.value <= 1){
            removeQtyBtn.classList.add('disabled')
        }
        else{
            removeQtyBtn.classList.remove('disabled')
        }
        if(inputQty.value >= 99){
            addQtyBtn.classList.add('disabled')
        }
        else{
            addQtyBtn.classList.remove('disabled')
        }
    }

    removeItem(key){
        this.beforeRemoveItem(key)
        this.minicartItems = this.minicart.querySelectorAll('.minicart__item')
        // console.log(this.minicartItems)
        removeFromCart(key).then(res => {
            // console.log(res)
            this.showContainerTotal()
            //Rimozione ultimo prodotto
            //!importante: se a rimanere a carrello come ultimo prodotto è la confezione regalo questa funzione VA AGGIORNATA
            if(res.rimuovi_confezione){
                this.minicartItems.forEach( minicartItem => {
                    let dataProductCategory = minicartItem.getAttribute('data-product-category')
                    // console.log(dataProductCategory)
                    if(dataProductCategory === 'confezione'){
                        let key = minicartItem.getAttribute('data-key')
                        // console.log(key)
                        this.beforeRemoveItem(key).then( () => {
                            this.showContainerTotal()                            
                        })
                    }
                })
            }
						if(res.related_removed){
							this.beforeRemoveItem(res.related_key)
							//let itemDeleted2 = this.minicart.querySelector('.minicart__item[data-key="' + res.related_key + '"]')
						}
            if (parseInt(res.total_prods) == 0) {
                if(productClass !== null){
                    productClass.closePopupAcquista()
                    productClass.movePopupAcquista('right')
                }
                //Se sono alla pagina checkout ed elimino l'ultimo prodotto, ricarico la pagina (il checkout reindirizzerà allo shop)
                if(document.querySelector('.page-single-product-vino') !== null){
                    headerClass.apriHeaderFeedVino()
                }
                if(document.querySelector('.page-checkout')){
                    location.reload()
                }
                else{
                    this.close().then( () => {
                        this.minicartEmpty.classList.remove('hidden')
                        awdScroll.start()
                        this.header.classList.add('active')
                        this.header.classList.remove('header-bloccato') 
                    })
                }
            }        
            else{
                if(document.querySelector('.page-checkout')){
                    document.dispatchEvent(new Event("update_checkout"))
                    document.querySelector('body').dispatchEvent(new Event("update_checkout")) 
                }
            }
            this.isAnimating = false
        })  
    }

    beforeRemoveItem(key) {
        return new Promise( resolve => {
            let itemDeleted = this.minicart.querySelector('.minicart__item[data-key="' + key + '"]')
            const totalItems = this.minicart.querySelectorAll('.minicart__item').length
            //Se rimane un solo elemento non faccio il fadein del contenitore del prezzo totale
            if(totalItems !== 1){
                this.hideContainerTotal()
            }
            gsap.to(itemDeleted.querySelector('.minicart__item__wrapper'), {
                duration: 0.4,
                autoAlpha: 0,
                onComplete: () => {
                    gsap.to(itemDeleted, {
                        height: 0,
                        onComplete: () => {
                            itemDeleted.remove()
                            resolve()
                        }
                    })
                }
            })

        })
    }    

    hideContainerTotal(){
        console.log('hide total')
        gsap.to(this.minicartContainerTotal, {
            duration: 0.4,
            autoAlpha: 0
        })

    }

    showContainerTotal(){
        gsap.to(this.minicartContainerTotal, {
            duration: 0.4,
            autoAlpha: 1
        })
    }
}

export {Minicart}